import { render, staticRenderFns } from "./ModalAlertConfigEdit.vue?vue&type=template&id=58be98cc&scoped=true&lang=pug"
import script from "./ModalAlertConfigEdit.vue?vue&type=script&lang=js"
export * from "./ModalAlertConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalAlertConfigEdit.vue?vue&type=style&index=0&id=58be98cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58be98cc",
  null
  
)

export default component.exports